import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(private msalService: MsalService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> 
	{
		return from(this.handleAccess(request, next));
	}
	
	private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
		const activeAccount = this.msalService.instance.getActiveAccount();
		
		if (activeAccount) {
			try {
				const tokenResponse: AuthenticationResult = await this.msalService.instance
					.acquireTokenSilent({
						scopes: ['api://3862a48e-f645-4681-9a4d-c0d590e58e74/read'],
						account: activeAccount
					});
					
				const accessToken = tokenResponse.accessToken;

				if (accessToken) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${accessToken}`
						}
					});
				}
			} catch (error) {
				console.error('Token acquisition failed', error);
			}		
		}
		return next.handle(request).toPromise();
	} 
}